(function() {
    'use strict';

    angular.module('user')
        .controller('ModelPermissionsGroupListController', ModelPermissionsGroupListController);

    ModelPermissionsGroupListController.$inject = ['$state', 'modelPermissionsGroupDataSrvc', 'modelPermissionsGroupSrvc', 'lodashService', 'notificationSrvc', 'modelPermissionsGroupMessagesConst', 'datatableDefaultPageSizeValueConst', 'checkSearchSrvc', 'modelPermissionsGroupPermissionsConst', 'filterQuerySrvc'];

    function ModelPermissionsGroupListController($state, modelPermissionsGroupDataSrvc, modelPermissionsGroupSrvc, lodashService, notificationSrvc, modelPermissionsGroupMessagesConst, datatableDefaultPageSizeValueConst, checkSearchSrvc, modelPermissionsGroupPermissionsConst, filterQuerySrvc) {
        var self = this;

        self.loading = true;

        self.pageOpts = {
            count: undefined,
            page: 1,
            pageSize: datatableDefaultPageSizeValueConst
        };

        self.modelPermissionsGroupRows = [];
        self.modelPermissionsGroupCols = [{
            title: 'Nazwa',
            value: 'name',
            searchable: true,
            orderable: true,
        }];
        self.modelPermissions = modelPermissionsGroupPermissionsConst;

        self.searchQuery = {
            name: null,
            ordering: null
        };

        self.onCreate = onCreate;
        self.onEdit = onEdit;
        self.onDelete = onDelete;

        self.pageChange = pageChange;
        self.onSearchQueryChange = onSearchQueryChange;

        activate();

        function activate() {
            self.pageOpts = filterQuerySrvc.initializePageOpts(self.pageOpts);
            self.searchQuery = filterQuerySrvc.initializeSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            getModelPermissionsGroups();
        }

        function getModelPermissionsGroups(filterObj) {
            self.loading = true;

            if (!filterObj) {
                filterObj = {
                    page: self.pageOpts.page,
                    page_size: self.pageOpts.pageSize,
                    name: self.searchQuery.name,
                    ordering: self.searchQuery.ordering
                };
            }
            return modelPermissionsGroupDataSrvc.list(filterObj)
                .$promise
                .then(
                    function(response) {
                        self.modelPermissionsGroupRows = response.results;
                        self.pageOpts.count = response.count;
                        return response;
                    },
                    function(response) {
                        if (response.status === 404 && filterObj.page !== 1) {
                            checkSearchSrvc.recall(filterObj, getModelPermissionsGroups);
                        }
                    }
                ).finally(
                    function(response) {
                        self.loading = false;
                        return response;
                    }
                );
        }

        function onCreate() {
            $state.go('layout.modelPermissionsGroup.create');
        }

        function onEdit(row) {
            $state.go('layout.modelPermissionsGroup.update', { pk: row.pk });
        }

        function onDelete(row) {
            return modelPermissionsGroupSrvc.remove(row.name, row.pk, function(response) {
                notificationSrvc.notification("success", modelPermissionsGroupMessagesConst.delete);
                lodashService.remove(self.modelPermissionsGroupRows, { pk: row.pk });
                return response;
            });
        }

        function pageChange() {
            filterQuerySrvc.updatePageOpts(self.pageOpts);
            filterQuerySrvc.setLocationParams();
            return getModelPermissionsGroups();
        }

        function onSearchQueryChange() {
            filterQuerySrvc.updateSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            return getModelPermissionsGroups();
        }
    }
})();
